export default __webpack_public_path__ + "static/media/coins.20716ea3.png";